import { Search } from 'lucide-react';
import type { DateFilters } from '../../types';

interface OrderFilterBarProps {
  filters: DateFilters;
  count: number;
  onFilterChange: (field: keyof DateFilters, value: string) => void;
  onClearFilters: () => void;
}

/** Compact toolbar that sits under the Orders card header. */
function OrderFilterBar({ filters, count, onFilterChange, onClearFilters }: OrderFilterBarProps) {
  return (
    <div className="card-toolbar">
      <div className="field-search" style={{ width: '240px' }}>
        <Search size={12} aria-hidden="true" />
        <input
          type="text"
          placeholder="Filter by recipient…"
          aria-label="Filter by recipient"
          value={filters.search || ''}
          onChange={(e) => onFilterChange('search', e.target.value)}
        />
      </div>
      <input
        className="input-compact"
        style={{ width: '120px' }}
        type="date"
        aria-label="Start date"
        value={filters.startDate || ''}
        onChange={(e) => onFilterChange('startDate', e.target.value)}
      />
      <input
        className="input-compact"
        style={{ width: '120px' }}
        type="date"
        aria-label="End date"
        value={filters.endDate || ''}
        onChange={(e) => onFilterChange('endDate', e.target.value)}
      />
      <button type="button" className="btn btn-ghost btn-small" onClick={onClearFilters}>
        Clear
      </button>
      <span className="mono-counter" style={{ marginLeft: 'auto' }}>
        {count} shown
      </span>
    </div>
  );
}

export default OrderFilterBar;
